import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { connect } from 'react-redux'
import { itemsFetchSinglePost, deleteExistingPost } from '../actions/index'
import Comments from '../components/Comments'
import Trash from '../images/trash-simple.svg'


class Post extends React.Component {

    componentDidMount() {
        this.props.fetchData(this.props.activePostID)
    }

    renderLoadingMessage = () => {
      if (this.props.hasErrored) {
        return <p>Sorry! There was an error loading the items</p>;
      }
    }

    deletePostEvent = (postID) => {
      this.props.deletePost(postID)
      this.props.history.push('/forum');
    }


    render() {


    return(

      

      <div>
        <Header />

        <div className="post-container">

        

          <div className="post-object">

            {this.renderLoadingMessage()}

              <h1 style={{marginTop: 0, textAlign: 'center', marginBottom: 5}}>{this.props.activePost.title}</h1>
              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <img alt="" src={this.props.activePost.gravatar} style={{borderRadius: 50, maxHeight: '50px', marginRight: 10}} />
                
                
                <h4 style={{textAlign: 'center'}}>Posted by {this.props.activePost.authorName} on {this.props.activePost.date}</h4>
              </div>
              <p style={{textAlign: 'center'}}>{this.props.activePost.body}</p>

              { 

                (this.props.currentUser.email === 'nathangaw@garneteducation.com') 

                ?

                  <div className="comment-edit-buttons" style={{display: 'flex', justifyContent: 'flex-end'}}>

                    <img alt="" src={Trash} className="edit-icons" style={{width: 20, height: 20, marginRight: 20, marginBottom: 20}} onClick={ () => { if (window.confirm('Are you sure you want to delete this post?'))this.deletePostEvent(this.props.activePost._id)}}></img>

                  </div>

                :

                <div></div>

                }

              <hr />

            </div>

          
          

          <Comments />

        </div>

        <Footer />

      </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {
        activePostID: state.router.location.pathname.substring(state.router.location.pathname.lastIndexOf('/')+1),
        activePost: state.activePost,
        isLoading: state.itemsIsLoading,
        currentUser: state.user
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (id) => dispatch(itemsFetchSinglePost(id)),
        deletePost: (postId) => dispatch(deleteExistingPost(postId))
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(Post)




// WEBPACK FOOTER //
// ./src/components/Post.js